import React from "react"
import PropTypes from "prop-types"
import { Button } from "@planningcenter/tapestry-react"
import { Checkbox } from "components/ui"

const Card = ({
  item,
  primaryField,
  secondaryFields,
  footerField,
  onCardClick,
  isDeletable,
  onDeleteClick,
  isSelectable,
  onSelectChange,
  selectableField = "selected"
}) => {
  /**
   * Renders a field for the card. A field could be
   *   A string -                   Ex: object[string]
   *   A function -                 Ex: item => `${item.lastName}, ${item.firstName}`
   *   A react function component - Ex: (props) => <MyComponent {...props} />
   */
  const renderDynamicCardField = prop => {
    if (typeof prop === "string") {
      // Consumer passed a property of the item
      return item[prop]
    } else if (typeof prop === "function") {
      // Consumer passed a render function or a component
      return prop(item)
    }
  }

  /**
   * Stops propagation of click event and handles delete.
   */
  const handleDeleteClick = e => {
    e.stopPropagation()
    onDeleteClick(item)
  }

  return (
    <div
      className="card"
      role={onCardClick ? "button" : "div"}
      onClick={() => onCardClick && onCardClick(item)}
      onKeyPress={() => onCardClick && onCardClick(item)}
    >
      {isSelectable && (
        <Checkbox
          name={`selectable-${item.id || item.key}`}
          htmlFor={`selectable-${item.id || item.key}`}
          value={`${item.id || item.key}`}
          onSelect={() => onSelectChange(item)}
          checked={item[selectableField]}
          labelClasses="pl-2"
        />
      )}
      <div className="card__content">
        <div>
          {primaryField && (
            <div className="card__primary">{renderDynamicCardField(primaryField)}</div>
          )}
          {secondaryFields?.length &&
            secondaryFields.map(field => (
              <div key={field} className="card__secondary">
                {renderDynamicCardField(field)}
              </div>
            ))}
        </div>
        {footerField && <div className="card__footer">{renderDynamicCardField(footerField)}</div>}
      </div>
      {isDeletable && (
        <div className="card__delete">
          <Button
            className="c-neutral-300"
            icon={{ name: "general.trash" }}
            tooltip={{ title: "Delete" }}
            theme="naked"
            onClick={handleDeleteClick}
          />
        </div>
      )}
    </div>
  )
}

Card.propTypes = {
  item: PropTypes.object,
  primaryField: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  secondaryFields: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node])
  ),
  footerField: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  onCardClick: PropTypes.func,
  isDeletable: PropTypes.bool,
  onDeleteClick: PropTypes.func,
  isSelectable: PropTypes.bool,
  onSelectChange: PropTypes.func,
  selectableField: PropTypes.string
}

export default Card
